// const debug = "SessionEventProto"
import {SessionEventData} from "./@type";

const debug = false

export default class SessionEventProto {

    public sessionEvent       : any
    public fromSID            : ID
    public uid                : ID
    public data               : any
    public companyId?         : ID
    public method             : string

    constructor(sessionEvent : SessionEventData) {

        this.sessionEvent   = sessionEvent
        this.uid            = sessionEvent.uid;
        this.data           = sessionEvent.data;
        this.fromSID        = sessionEvent.fromSID
        this.companyId      = sessionEvent.companyId;
        this.method         = sessionEvent.method
    }

    validate() {
        return true;
    }

    isDifferentCompany() {
        return (this.companyId && this.companyId !== gd.companyId);
    }

    // process() {
    //
    //     if (this.isDifferentCompany()) return
    //
    // }

}
